<template>
  <div >
    <modal full-header @close="closeModal" >
      <template slot="body">
        <div class="container"  :class="isSushiHub && 'background-blue'">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 "  :class="isSushiHub ? 'text-white montserrat-bold' : 'privacy-header'">{{ $t("message.termsAndConditions") }}</h2>
          </div>
        </div>

        <div class="container">

          <p class="py-4" v-html="privacyAndPolicy()"></p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index:2">
          <button  :class="isSushiHub ? 'curved-10 background-sushi privacy-btn-sushi text-white border-0' : 'privacy-btn' " class=" pull-right" data-dismiss="modal">{{ $t('message.ok') }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
  </div>
</template>

<style>
.background-blue {
  background-color: #75E3FA;
}
.background-sushi {
   background-color: #F04653 !important;
 }

</style>

<script>
import { mapGetters } from "vuex";
import modal from "../../modal.vue";

export default {
  components: {
    modal
  },
  props: {
    isSushi : {
      type: Boolean
    },

  },
  computed: {
    ...mapGetters(["currentStoreDoc","hqDoc", "getTermsAndConditions"]),
    isSushiHub() {
      return this.hqDoc  && this.hqDoc.IsSushiHub;
    }
  },
  methods: {
     privacyAndPolicy() {
       if(this.isSushiHub && this.getTermsAndConditions){
          return this.getTermsAndConditions
       }

      if (this.isBranded() && this.hqDoc && this.hqDoc.TermsAndConditions) {
        return this.hqDoc.TermsAndConditions;
      } else {
        return this.currentStoreDoc.TermsAndConditions;
      }
    },
    closeModal() {
      this.$emit("close-modal");
    },
  }
};
</script>
